import { h, Host } from "@stencil/core";
export class UxSkeleton {
    constructor() {
        this.count = 1;
    }
    render() {
        return (h(Host, { key: 'de25e16c2760b86e129b6cb0942f29518673ae30', role: "status", "aria-live": "polite", "aria-busy": "true" }, Array.from({ length: this.count }).map(() => (h("div", { class: "item", "aria-hidden": "true" })))));
    }
    static get is() { return "ux-skeleton"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["skeleton.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["skeleton.css"]
        };
    }
    static get properties() {
        return {
            "count": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Number of skeleton items to render"
                },
                "attribute": "count",
                "reflect": false,
                "defaultValue": "1"
            }
        };
    }
}
//# sourceMappingURL=skeleton.js.map
